module.exports = __webpack_public_path__ + "static/media/scroll-down.915e3842.gif";